import React, { lazy, useEffect, useState, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { startCase } from 'lodash';
import Select from 'react-select';
import { Card } from 'reactstrap';
import { useSession } from '@cordata/buffet';
import { PageLayout } from '~/components';

const reportComponents = {
  CustodyFlagReport: lazy(() => import('./CustodyFlagReport')),
};

const CustomReports = () => {
  const { reportName } = useParams();
  const { current } = useSession();
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [selectedDivisions, setSelectedDivisions] = useState([]);

  useEffect(() => {
    if (current) {
      setDivisionOptions(current.attributes.accessibleDivisions.map(d => ({
        label: d.divisionName,
        value: d.divisionUid,
      })));
    }
  }, [current]);

  useEffect(() => {
    if (!selectedDivisions.length) {
      setSelectedDivisions(divisionOptions.filter(d => d.value ===
                                                     current.attributes.currentDivisionUid));
    }
  }, [divisionOptions]);

  const setComponent = () => {
    const Component = reportComponents[reportName];
    if (!Component) return <h1>Report not found</h1>;

    return (
      <Component
        selectedDivisions={selectedDivisions}
      />
    );
  };

  return (
    <Suspense fallback="Loading...">
      <PageLayout
        title={startCase(reportName)}
        titleAction={
          <Select
            className="filter-container"
            value={selectedDivisions}
            onChange={setSelectedDivisions}
            options={divisionOptions}
            isMulti
          />
        }
      >
        <Card className="h-100">
          { setComponent() }
        </Card>
      </PageLayout>
    </Suspense>
  );
};

export default CustomReports;
